<ng-template
	#affixTemplate
	let-row>
	@if (!row.accepted) {
<app-card-table-actions
		[row]="row"
	
		[listActions]="listActions"
		[actions]="rowActions"
		(actionEvent)="onAction($event)"
		[breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
}

	@if (row.accepted) {
<app-card-table-actions
		[row]="row"
	
		[actions]="acceptedRowActions"
		(actionEvent)="onAction($event)"
		[breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
}
</ng-template>

@if (firstLoad && loadingRingFenceAlerts) {
<mat-spinner
	class="spinner mauto"

	name="crescent"></mat-spinner>
}

<app-generic-table-header
	[config]="headerOptions"
	(refreshEvent)="refreshData($event)">
</app-generic-table-header>
@if (!firstLoad) {
<app-card-table
	#RFATable

	[data]="data"
	[options]="options"
	[affixTemplate]="affixTemplate"
	[enableInfiteScroll]="false"
	[enableRefresher]="false"
	[enableTablePagination]="true"
	[tableHeaders]="headers"
	[totalItems]="totalRingFenceAlerts"
	[currentPage]="currentPage"
	(dataScrolledEvent)="loadMoreData($event)"
	(paginateEvent)="getPagedAlerts($event)"
	[breakpoint]="ScreenSize.TABLET">
</app-card-table>
}

@if (data.length == 0 && !firstLoad) {
<div

	class="noAlerts">
	<span class="card-header">No alerts to display</span>
</div>
}
